<template>
  <div>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top: 20px">
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column label="名称" prop="NAME"></el-table-column>
          <!-- <el-table-column label="需求量" prop="PRODUCT_COUNT"></el-table-column>
                    <el-table-column label="报价" >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.SUBMIT_PRICE" :disabled="isDisabled"></el-input>
                        </template>
                    </el-table-column> -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button v-preventReClick type="text" @click="checkPrice(scope.row)" :disabled="isDisabled">查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-pagination :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
        :total="totalCount" @current-change="handleCurrentChange" style="float:right">
      </el-pagination>
    </el-row>
    <!-- <el-row>
            <el-button v-preventReClick style="float: right;margin-top: 20px" @click="overPrice()" type="primary" v-show="priceStatus === 1">报价完成</el-button>
        </el-row> -->
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      totalCount: 0,
      pageSize: 9999,
      currentPage: 1,
      priceStatus: 0,
      isDisabled: false,
    };
  },
  methods: {
    queryTable(index) {
      const params = {
        SERVICE_ID: '10063',
        OTYPE: 6,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        // SUPPLIER_ID:Number(sessionStorage.getItem("company_id")),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGEINDEX: index,
        PAGESIZE: this.pageSize,
        RECORD_ID: sessionStorage.getItem('recordId'),
        COMPARE_ID: sessionStorage.getItem('COMPARE_ID'),
      };
      http.post(params).then((result) => {
        if (result) {
          this.tableData = result;
          this.totalCount = result.length;
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    overPrice() {
      const params = {
        SERVICE_ID: '10063',
        OTYPE: 5,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        RECORD_ID: sessionStorage.getItem('recordId'),
      };
      http.post(params).then((result) => {
        this.$message.show({
          text: '报价完成',
          type: 'success',
        });
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable(e - 1);
    },
    checkPrice(row) {
      sessionStorage.setItem('F_CAT_ID', row.F_CAT_ID);
      this.$router.push({ name: 'mealCheckProductPrice' });
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.queryTable(0);
    // this.priceStatus = Number(sessionStorage.getItem('priceStatus'))
    // if (this.priceStatus === 1){
    //     this.isDisabled = false
    // }else{
    //     this.isDisabled = true
    // }
  },
};
</script>




// WEBPACK FOOTER //
// src/components/priceManagement/quoteDetails.vue